// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"73d094fb","453":"6df10faa","751":"0280a3b6"}[chunkId] + ".chunk.js";
};